import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "types";
import { initialState } from "app/containers/Features/components/MemberSelection/redux/initialState";

const selectDomain = (state: RootState) =>
  state.ticketTagsState || initialState;

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading,
);
export const selectButtonLoading = createSelector(
  [selectDomain],
  (state) => state.buttonLoading,
);

export const selectTagsForm = createSelector(
  [selectDomain],
  (state) => state.form,
);

export const selectTagDeleteModal = createSelector(
  [selectDomain],
  (state) => state.deleteModal,
);
export const selectIsSelectedId= createSelector(
  [selectDomain],
  (state) => state.selectedId,
);

